
<style lang="scss">
@import './sass/variables.scss';
@import './styles/sass/_index.scss';

.no-background-hover::before {
  background-color: transparent !important;
}

.flexcol .v-btn__content {
  flex-direction: column;
}

// ::v-deep .v-simple-table--click tbody tr.active {
//     background-color: rgba(76, 175, 80, 0.1);
// }

::v-deep .elevation-top {
  box-shadow: 0px 12px 16px -6px rgba(0, 0, 0, 0.56), 0px 24px 38px 3px rgba(0, 0, 0, 0.42), 0px 9px 46px 8px rgba(0, 0, 0, 0.36) !important;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: rgba(76, 175, 80, 0.1);
}

.v-simple-table--click tbody tr.active {
  background-color: transparent !important;
}

.tr-text:hover {
  background-color: transparent !important;
}

.gray-label .v-label {
  color: #000000;
}

.v-data-table__wrapper table td {
  padding: 0;
  border: none;
}

.v-data-table__wrapper table td {
  padding: 0;
  border: none;
}

.main-container {
  // position: absolute;
  // top: 0;
  // top: calc(env(safe-area-inset-top));
  // top: calc(constant(safe-area-inset-top));

  // left: 0;
  // right: 0;
  // bottom: env(safe-area-inset-bottom);
  // bottom: constant(safe-area-inset-bottom);
  // height: auto;
  // overflow-y: scroll;
  // overflow-x: visible
}

.floating-form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  padding-top: calc(env(safe-area-inset-top));
  padding-top: calc(constant(safe-area-inset-top));
  background-color: #fff;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.2);
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 40px;
  padding-top: calc(env(safe-area-inset-top));
  padding-top: calc(constant(safe-area-inset-top));
  z-index: 99;
  background-color: #fff;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.2);
}

.dialog-area {
  position: absolute;
  // top: env(safe-area-inset-top);
  // top: constant(safe-area-inset-top);
  padding-top: calc(env(safe-area-inset-top));
  padding-top: calc(constant(safe-area-inset-top));
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow-y: auto;
}

.disable-select {
  position: absolute;
  top: 40px;
  top: calc(env(safe-area-inset-top) + 60px);
  top: calc(constant(safe-area-inset-top) + 60px);

  left: 0;
  right: 0;
  padding-bottom: calc(env(safe-area-inset-bottom) + 20px);
  padding-bottom: calc(constant(safe-area-inset-bottom) + 20px);
  // height: auto;
  // overflow-y: scroll;
  // overflow-x: scroll
}
</style>
<template>
  <!-- <v-app v-touch="{ right: toBack }"> -->
  <v-app v-touch="{ right: toBack }"
    :style="currentCompentName === '/admin' ? { backgroundColor: 'rgb(239, 237, 237)' } : {}">

    <div>
      <Header v-if="currentCompentName === '/' || currentCompentName === '/myInfo'"
        :class="isIOS === true ? 'header' : ''"></Header>
      <router-view :class="isMobile === true && currentCompentName.startsWith('/admin') === false ? 'disable-select' : ''"
        id="route" />
    </div>
    <div class="footer"></div>
    <v-snackbar v-model="snackbar" bottom :timeout="2000" rounded="rounded-xxl" content-class="text-center">
      새로운 메시지가 도착하였습니다.
    </v-snackbar>

    <template>
      <v-dialog v-model="errorDialog" max-width="290">
        <v-card>
          <div>
            <v-card-text class="text-center pb-3 pt-4 px-0" style="white-space: pre-line; color: black;">
              예상치 못한 오류가 발생하였습니다.
              <br />
              계속 같은 현상이 발생할 경우
              <br />
              관리자에게 문의해주세요.
            </v-card-text>
            <v-card-text class="py-0">
              <v-divider />
            </v-card-text>
            <v-card-text class="text-center pb-3 pt-3 d-flex align-start">
              <v-row>
                <v-col cols="12">
                  <v-btn block :ripple="false" width="120" height="20px" class="px-0 text--secondary no-background-hover"
                    text large @click="errorDialog = false">
                    확인
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
    </template>
  </v-app>
</template>

<script>
import Header from './components/Header'
import * as loginAPI from './login'
import * as pushAPI from './components/push/pushAPI'
import * as commonFunction from './components/commonFunction'
export default {
  name: 'App',
  created () {
    this.prevPath = this.currentCompentName
    this.currentCompentName = this.getCurrentPath
    if (commonFunction.isMobile()) {
      this.$store.commit('pushStore/resetRouterItem', {})
      if (commonFunction.isAndroid()) {
        window.onBackPressed = this.onBackPressed
      }
      if (this.getUserID !== '') {
        window.getAppInfo = this.getAppInfo

        window.handleFCMData = this.handleFCMData

        if (commonFunction.isIOS()) {
          window.webkit.messageHandlers.SettingsCallbackHandler.postMessage('func=getAppInfo')
        } else {
          window.Settings.getAppInfo()
        }
        window.handleAppForeground = this.handleAppForeground

        this.$router.push({ name: 'simpleAuth' })
      }
    }

    if (this.getIndex === 0) {
      this.$store.commit('mutationIndex', 1)
    }
  },

  beforeUpdate () {
    this.backPressedCount = 0
  },

  components: {
    Header
  },

  watch: {
    getCurrentPath (payload) {
      this.prevPath = this.currentCompentName
      this.currentCompentName = payload
    },

    getIsOpenErrorDialog (newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.errorDialog = true
      }
    },

    errorDialog () {
      if (this.errorDialog) {
        this.$store.commit('mutationIsOpenErrorDialog', false)
      }
    }
  },

  mounted () {
    if (commonFunction.isMobile()) {
      if (commonFunction.isIOS()) {
        this.isIOS = true
      }
      this.isMobile = true
    }
  },

  computed: {

    getUserID: function () {
      return this.$store.getters['userStore/getUserID']
    },

    getPassword: function () {
      return this.$store.getters['userStore/getPassword']
    },

    getUserInfo: function () {
      return this.$store.getters['userStore/getUserInfo']
    },

    getCurrentPath: function () {
      return this.$store.getters.getCurrentPath
    },

    getIndex: function () {
      return this.$store.getters.getIndex
    },

    getRouterItem: function () {
      return this.$store.getters['pushStore/getRouterItem']
    },

    getIsOpenErrorDialog: function () {
      return this.$store.getters.getIsOpenErrorDialog
    }
  },

  data: () => ({
    permission: '',
    token: '',
    currentCompentName: '',
    index: 0,
    backPressedCount: 0,
    snackbar: false,
    isIOS: false,
    prevPath: '',
    errorDialog: false,
    isMobile: false,
    isClickFCM: false
  }),

  methods: {
    getOsVersion () {
    },

    toBack () {
      if (commonFunction.isIOS()) {
        if (this.currentCompentName === '/simpleAuth' && (this.prevPath === '/myInfo' || this.prevPath === '/pinResetAuth')) {
          this.$router.go(-1)
        }
      }
    },

    onBackPressed () { // 안드로이드 뒤로가기 함수
      if (this.currentCompentName === '/' || this.currentCompentName === '/login' || (this.currentCompentName === '/simpleAuth' && (this.prevPath !== '/myInfo' && this.prevPath !== '/pinResetAuth'))) {
        if (this.backPressedCount === 0) {
          this.backPressedCount = 1
          window.Common.onBackPressed() // 토스트만 띄우는 함수
          setTimeout(() => {
            this.backPressedCount = 0
          }, 3000)
        } else {
          this.backPressedCount = 0
          window.Common.finishActivity() // 종료 함수
        }
      } else {
        this.$router.go(-1)
      }
    },

    getAppInfo (appInfo) {
      this.isActiveUser()
      this.appInfo = JSON.parse(appInfo)
      const FCMKey = this.appInfo.fcmToken
      loginAPI.getToken(this.$store.getters['userStore/getUserID'], this.$store.getters['userStore/getPassword'], FCMKey)
    },
    userCheck () {
      loginAPI.isActiveUser(this.getUserID, this.getPassword)
        .then((res) => {
          if (res.status >= 400) {
            this.$store.commit('userStore/mutatinResetUserINfo')
            this.$router.push('/login')
          }
        })
    },

    handleFCMData (fcmData) { // FCM DATA 수신 함수
      let pushData = JSON.parse(fcmData) // FCM Data Json
      let typeKeyValue = pushData.typeKeyValue
      this.isClickFCM = true
      let isForeground = pushData.isForeground
      let teamCode = ''
      let trequestID = ''

      if (typeKeyValue.includes('/')) { // 요청관리인 경우
        [trequestID, teamCode] = typeKeyValue.split('/')
      }

      this.resetMutation()
      let payload = {
        pushData: pushData
      }
      this.$store.commit('pushStore/mutationRouterItem', payload)
      if (isForeground === false) {
        if (this.currentCompentName !== '/simpleAuth') {
          if (pushData.pushType === 'newRequest' || pushData.pushType === 'newRequestStatus') {
            this.$router.push({ name: 'testRequestDetail', params: { id: trequestID, teamCode: teamCode } })
          } else if (pushData.pushType === 'newIncongruity' || pushData.pushType === 'newIncongruityFeedBack') {
            this.$router.push({ name: 'testIncongruityDetail', params: { id: typeKeyValue } })
          } else if (pushData.pushType === 'newClient' || pushData.pushType === 'newClientConfirm' || pushData.pushType === 'newClientConfirmFinal') {
            this.$router.push({ name: 'clientInfo', params: { id: typeKeyValue, type: pushData.pushType } })
          } else if (pushData.pushType === 'newNotice') {
            this.$store.commit('noticeStore/mutationNoticeID', typeKeyValue)
            this.$router.push({ name: 'readNotice' })
          } else if (pushData.pushType === 'newSpecimen') {
            let time = pushData.time
            this.$router.push({ name: 'specimenPushList', params: { time: time } })
          } else if (pushData.pushType === 'newVOC') {
            this.$router.push({ name: 'vocDetail', params: { id: typeKeyValue } })
          } else if (pushData.pushType === 'newNoticeEncouraging') {
            this.$router.push({ name: 'noticeList' })
          } else if (pushData.pushType === 'newRequestEncouraging') {
            this.$router.push({ name: 'testRequest' })
          } else if (pushData.pushType === 'newIncongruityEncouraging') {
            this.$router.push({ name: 'testIncongruity' })
          } else if (pushData.pushType === 'newVOCEncouraging') {
            this.$router.push({ name: 'voc' })
          } else if (pushData.pushType === 'newIssueReminder') {
            this.$router.push({ name: 'testIssueReminder' })
          }
        }
      } else {
        this.snackbar = true
      }
    },

    handleAppForeground () { // Background to foreground 리프레쉬 함수
      this.isActiveUser() // 활성 유저 여부 확인
      this.resetMutation() // 알림 오버라이트
      this.$store.commit('mutationIsRefresh', true)
    },

    isActiveUser () { // 활성 유저 여부 확인
      loginAPI.isActiveUser(this.getUserID, this.getPassword)
        .then((res) => {
          if (res.data.result.isActive === false || (res.status && res.status >= 400)) {
            this.$store.commit('userStore/mutatinResetUserINfo')
            this.$router.push('/login')
          }
        })
    },

    resetMutation () { // pushMutation 비우고 새로 오버라이트
      let payload = {
        id: this.getUserID,
        password: this.getPassword
      }
      this.$store.commit('pushStore/mutationReset', payload)
    }
  },
  beforeRouteEnter (to, from, next) {
    const resetViewportStyle = () => {
      const body = document.body
      body.style.paddingTop = 'env(safe-area-inset-top)'
      body.style.paddingBottom = 'env(safe-area-inset-bottom)'
    }

    // 다음 Vue 컴포넌트가 마운트된 후 스타일을 재설정합니다.
    next(vm => {
      resetViewportStyle()
    })
  }
}
</script>
